import React, { FC } from 'react'

import { Title } from '@Components/CMS/Title'
import { useTranslation } from '@Globals/Translations'

import styles from './WishList.module.scss'

interface WishListEmptyProps {
  id?: string
}

const WishListEmpty: FC<WishListEmptyProps> = ({ id }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper} id={id}>
      <Title bold title={t('cms:MY_WISH_LIST')} type="h2" />
      <p>{t('cms:EMPTY_WISH_LIST_TEXT')}</p>
    </div>
  )
}

export default WishListEmpty
